import React from 'react'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SelectUI from '../../../widgets/input/SelectUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import CardUI from '../../../widgets/layout/CardUI.js'
import FeesNavUI from '../../../components/superUser/loanList/FeesNavUI'
import './FeesTrackerPage.css'

const FeesTrackerPageUI = ({ context, errorList, accountFeeList, onRefreshClick,
  financialYear, financialYearList, onFinancialYearChange }) =>
  <SuperUserHomePageUI context={context} className='pg_su_fee_tkr' topnav='accounts'
    headerText='Processing Fees' centered={!errorList || !accountFeeList} page='fees'
  >
    {
      (!errorList || !accountFeeList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      accountFeeList &&
      <div>
        <div className='su_fee'>
          <LRTableActionsUI location='top'
            left={
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                <span className='g_m_left_100 g_large'><b>Processing Fees</b></span>
              </span>
            }
            right={
              <span className='g_flex_h g_flex_right'>
                <SelectUI selectedKey={financialYear} optionList={financialYearList} onChange={onFinancialYearChange} placeholder='Financial year' />
              </span>
            }
          />
        </div>
        <FeesNavUI page='feeTracker2' />

        <ProcFeesUI context={context} accountFeeList={accountFeeList} />

      </div>
    }
  </SuperUserHomePageUI>

const ProcFeesUI = ({ context, accountFeeList }) =>
  <CardUI>
    <table>
      <thead>
        <tr className='head'>
          <th className='g_text_right amt'>S no.</th>
          <th className='g_text_right amt'>Account/Loan</th>
          <th className='g_text_right amt'>Processing Fee 1</th>
          <th className='g_text_right amt'>GST1</th>
          <th className='g_text_right amt'>TDS1</th>
          <th className='g_text_right amt'>Processing Fee 2</th>
          <th className='g_text_right amt'>GST2</th>
          <th className='g_text_right amt'>TDS2</th>
        </tr>
      </thead>
      <tbody>
        {
          accountFeeList && accountFeeList.map((account, i) =>
            <>
              <tr key={i} className='acc'>
                <td className='left'>{i + 1}</td>
                <td className='left g_no_wrap_2'>{account.accountName}</td>
              </tr>
              {
                account.loanFeeTrackerList.map((loanFee, j) =>
                  <tr key={j} className='loan'>
                    <td className='left'>{i + 1}.{j + 1}</td>
                    <td className='left g_no_wrap_2'>{loanFee.loanName}</td>
                    <td className='g_text_right amt'>{loanFee.procFee1Paid.amountWithoutTaxF2}</td>
                    <td className='g_text_right amt'>{loanFee.taxProcessFee1}</td>
                    <td className='g_text_right amt'>{loanFee.tdsProcessFee1}</td>
                    <td className='g_text_right amt'>{loanFee.procFee2Paid.amountWithoutTaxF2}</td>
                    <td className='g_text_right amt'>{loanFee.taxProcessFee2}</td>
                    <td className='g_text_right amt'>{loanFee.tdsProcessFee2}</td>
                  </tr>
                )
              }
            </>
          )
        }
      </tbody>
    </table>
  </CardUI >


export default FeesTrackerPageUI
